import { HttpInterceptorFn } from '@angular/common/http';

export const orgContextInterceptor: HttpInterceptorFn = (req, next) => {
    const activeOrgId = localStorage.getItem('active_org_id');
    if (activeOrgId && !req.url.startsWith('./') && !req.url.endsWith('.json')) {
        req = req.clone({
            setHeaders: {
                'X-Organization-Id': activeOrgId
            }
        });
    }
    return next(req);
};
